import {
  TPrimaryInvoice,
  TTripInvoice,
} from "@helpers/validation-schemas/primary-sale-order/invoice.schema";
import { useGetPrimaryInvoiceQuery } from "@states/primary-sale-order/primary-invoice.api";
import { useGetTripInvoiceQuery } from "@states/trip/trip-invoice.api";
import { TGetOneSuccessResponse } from "@type-defs/general/TGetOneSuccessResponse";

const useGetOneTripInvoice = (id: any) => {
  const {
    data: rawData,
    error,
    isLoading,
    refetch,
  } = useGetTripInvoiceQuery({
    id: id!,
  });

  const tripInvoiceResponse = rawData as any;

  return {
    tripInvoiceData: tripInvoiceResponse?.data,
    tripInvoiceMessage: tripInvoiceResponse?.message,
    tripInvoiceSuccess: tripInvoiceResponse?.success,
    tripInvoiceError: error,
    tripInvoiceLoading: isLoading,
    tripInvoiceRefetch: refetch,
  };
};

export default useGetOneTripInvoice;
